var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscontinue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discontinue_icon",
    "data-name": "Discontinue icon",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M200.744,209.9a8,8,0,1,1,8-8A8.009,8.009,0,0,1,200.744,209.9Zm0-14.973a6.973,6.973,0,1,0,6.972,6.974A6.981,6.981,0,0,0,200.744,194.924Z",
    transform: "translate(-192.744 -193.897)",
    fill: "#b47714",
    stroke: "#b47714",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 10.501,
    height: 0.8,
    transform: "translate(2.883 7.6)",
    fill: "#b47714",
    stroke: "#b47714",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscontinue);
export default __webpack_public_path__ + "static/media/discontinue.098be77c2066c3bc45bea2633525f453.svg";
export { ForwardRef as ReactComponent };